import React, { useEffect, useRef, useState } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { CheckIcon, EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import DashboardHeaderManagementFiltersDrawer
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/filters/DashboardHeaderManagementFiltersDrawer';
import CalendarFiltersSettings from '@app/model/company_hotel/settings/CalendarFiltersSettings';
import DashboardHeaderSavedFiltersSegment
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/filters/DashboardHeaderSavedFiltersSegment';
import Utilities from '@util/Utilities';
import DashboardHeaderSavedFiltersListDrawer
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/filters/DashboardHeaderSavedFiltersListDrawer';
import useDrawer from '@app/component/overlays/drawer/DrawerRef';
import useModal from '@app/component/overlays/modal/ModalRef';
import DashboardHeaderCreateSavedFilterModal
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/filters/DashboardHeaderCreateSavedFilterModal';

const DashboardHeaderManageFiltersComponent: React.FunctionComponent<{
	companyHotel: CompanyHotel,
	onSave: (input: CalendarFiltersSettings) => any
}>
	= ({ companyHotel, onSave }) => {

	const [hiddenFiltersExist, setHiddenFiltersExist] = useState(false);
	const [showSecondFiltersRow, setShowSecondFiltersRow] = useState(false);
	const manageFiltersDrawer = useDrawer();
	const savedFiltersListDrawer = useDrawer();
	const createSavedFilterModal = useModal();

	useEffect(() => {
		setShowSecondFiltersRow(companyHotel.settings.calendarFilters.showSecondFiltersRow);
		setHiddenFiltersExist((!companyHotel.settings.calendarFilters.showSecondFiltersRow && companyHotel.settings.calendarFilters.filtersArrangement.some(f => f.row === 1))
			|| (companyHotel.settings.calendarFilters.showSecondFiltersRow && !companyHotel.settings.calendarFilters.filtersArrangement.some(f => f.row === 1 && !f.isHidden)));
	}, [companyHotel.settings.calendarFilters]);

	return <>
		<Menu as="div" className="relative">
			<MenuButton type="button" className="btn btn-white text-xs h-8 px-2.5 relative">
				<EllipsisVerticalIcon className="h-3 w-3 flex-shrink-0" />
				{hiddenFiltersExist &&
					<span className="absolute inline-flex rounded-full h-1.5 w-1.5 bg-green-500 right-1.5 top-1.5"></span>}
			</MenuButton>

			<MenuItems anchor="bottom end"
								 className="z-10 mt-3 w-56 origin-top-right overflow-hidden rounded-md bg-white divide-y divide-gray-100 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
				<div className="px-4 py-3">
					<p className="text-xs text-gray-500">
						Configure and manage your filters according to your needs. Also save your current filters to reuse them!
					</p>
				</div>
				<DashboardHeaderSavedFiltersSegment companyHotel={companyHotel} openSavedFiltersListDrawer={()=>savedFiltersListDrawer.open()} openCreateSavedFilterModal={() => createSavedFilterModal.open()}/>
				<div className="py-1">
					<MenuItem>
						{({ focus }) => <a
							onClick={() => manageFiltersDrawer!.open()}
							href="#"
							className={Utilities.menuItemClasses(focus)}>
							<span className="font-semibold block">Manage Filters</span>
						</a>}
					</MenuItem>
					<MenuItem>
						{({ focus }) => <a
							onClick={() => onSave({
								...companyHotel.settings.calendarFilters,
								showSecondFiltersRow: !companyHotel.settings.calendarFilters.showSecondFiltersRow,
							})}
							href="#"
							className={Utilities.menuItemClasses(focus)}>
							<span className="font-semibold block">Show Secondary Filters</span>
							{showSecondFiltersRow &&
								<span className="text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4">
											<CheckIcon className="h-5 w-5 text-green-500" />
									</span>}
						</a>}
					</MenuItem>
				</div>
			</MenuItems>
		</Menu>
		<DashboardHeaderManagementFiltersDrawer companyHotel={companyHotel} ref={manageFiltersDrawer.ref} onSave={onSave} />
		<DashboardHeaderSavedFiltersListDrawer companyHotel={companyHotel} ref={savedFiltersListDrawer.ref} />
		<DashboardHeaderCreateSavedFilterModal companyHotel={companyHotel} ref={createSavedFilterModal.ref} width='large'/>
	</>;
};

export default DashboardHeaderManageFiltersComponent;